import firebase from 'firebase'

export const FirebaseTimestamp = firebase.firestore.Timestamp
